import { render, staticRenderFns } from "./accountRole.vue?vue&type=template&id=6ea81163&"
import script from "./accountRole.vue?vue&type=script&lang=js&"
export * from "./accountRole.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports